import { useQuery } from '@tanstack/react-query';
import { Button, Form, Select, Spin } from 'antd';
import apiCompaniesCall from 'apps/futureflex/apiCalls/company/list';
import { useFetchApiList } from 'hooks/api';
import LoadingSpinner from 'common/ui/LoadingSpinner';
import debounce from 'lodash/debounce';
import QueryString from 'qs';
import { useEffect, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

const debounceTimeout = 800;

const FilterForm = ({ form, name }) => {
  let [filterParams, setSearchParams] = useSearchParams();

  const {
    data: companies = [],
    load: loadCompanies,
    isLoading: isLoadingCompanies,
    loadMore: loadMoreCompanies,
  } = useFetchApiList(apiCompaniesCall, { resourceName: 'data' });

  const debounceFetcher = useMemo(() => {
    const loadOptions = value => {
      loadMoreCompanies({ search: value });
    };
    return debounce(loadOptions, debounceTimeout);
  }, [loadCompanies, debounceTimeout]);

  const handleSubmit = params => {
    const p = JSON.parse(JSON.stringify(params));
    setSearchParams(p);
  };

  useEffect(() => {
    loadCompanies();
  }, []);

  if (isLoadingCompanies) {
    return <LoadingSpinner />;
  }

  return (
    <Form
      form={form}
      layout="inline"
      name={name || 'filter_form'}
      onFinish={handleSubmit}
      initialValues={QueryString.parse(filterParams.toString())}
    >
      <Form.Item name="company_id" label="Company">
        <Select
          style={{ width: 300 }}
          onPopupScroll={e => {
            e.persist();
            let target = e.target;
            if (
              target.scrollTop + target.offsetHeight ===
              target.scrollHeight
            ) {
              loadMoreCompanies();
            }
          }}
          onSearch={debounceFetcher}
          notFoundContent={isLoadingCompanies ? <Spin size="small" /> : null}
          showSearch
          optionFilterProp="children"
          filterOption={(input, option) =>
            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
          }
          placeholder="Search Email / Full name"
          options={companies.map(({ id, email, name }) => ({
            value: id,
            label: name + ' / ' + email,
          }))}
        />
      </Form.Item>

      <Button type="primary" htmlType="submit">
        Filter
      </Button>
    </Form>
  );
};

export default FilterForm;
